import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Swal from 'sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}
Vue.use(router)
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
